import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Card, CardBody, Form, Button } from "reactstrap";
import { useLocation, useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../../../config";
import Loader from "../../../Helper/Loader";
import Breadcrumbs from "../../../Helper/Breadcrumbs";
import empty from "is-empty";

const CategoryForm = () => {
  const location = useLocation();
  const history = useHistory();
  const { id, editMode } = location.state || {};

  const tokenKey = {
    Authorization: "Token " + sessionStorage.getItem("tokenKey"),
    "Content-Type": "application/json",
  };

  const toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: true,
  };

  const breadcrumbData = [
    { title: "Seobook", href: "/seobook" },
    { title: "Categories", href: "/seobook/blogcategory" },
    { title: editMode ? "Edit" : "Create", href: "#" },
  ];

  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);

  // Fetch category data for edit mode
  useEffect(() => {
    const fetchCategory = async () => {
      if (editMode && id) {
        try {
          const res = await axios.get(
            `${config.service}/masters/blog-categories/${id}/`,
            { headers: tokenKey }
          );
          setFormData(res.data);
        } catch (err) {
          toast.error("Failed to fetch category data", toastAttr);
        }
      }
      setLoading(false);
    };
    fetchCategory();
  }, [editMode, id]);

  const handleInput = useCallback(
    (key, value) => {
      setFormData((prev) => ({ ...prev, [key]: value }));
      if (errors[key]) setErrors((prev) => ({ ...prev, [key]: null }));
    },
    [errors]
  );

  const validateForm = useCallback(() => {
    const newErrors = {};
    if (empty(formData.name)) newErrors.name = "Category name is required";
    return newErrors;
  }, [formData]);

  const saveForm = useCallback(async () => {
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.error("Please fix errors before submitting", toastAttr);
      return;
    }

    setLoading(true);

    const url = editMode
      ? `${config.service}/masters/blog-categories/${id}/`
      : `${config.service}/masters/blog-categories/`;
    const method = editMode ? "put" : "post";

    try {
      await axios({
        url,
        method,
        headers: tokenKey,
        data: formData,
      });
      toast.success(
        `Category ${editMode ? "updated" : "created"} successfully`,
        toastAttr
      );
      history.push("/seobook/blogcategory");
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Operation failed", toastAttr);
    } finally {
      setLoading(false);
    }
  }, [formData, editMode, id]);

  return (
    <Container style={{ padding: 0 }}>
      <Row >
        <Col md={10}>
          <Card>
            <CardBody>
              <div className="card__title pageNav">
                <div className="bold-text">
                  <Breadcrumbs data={breadcrumbData} />
                </div>
              </div>
              <div className="formBtnsDiv mb-3">
                <h4 className="mb-4">
                  {editMode ? "Edit Category" : "Create Category"}
                </h4>
              </div>

              <Loader loading={loading}>
                <Form>
                  <Row className="mb-3 shadow-sm ">
                    <Col md={12} className="d-flex gap-2">
                      <Button color="primary" onClick={saveForm}>
                        {editMode ? "Update" : "Save"}
                      </Button>
                      <Button
                        color="secondary"
                        onClick={() => history.push("/seobook/blogcategory")}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mb-3 align-items-center">
                    <Col md={3}>
                      <label className="fw-bold">Category Name *</label>
                    </Col>
                    <Col md={9}>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.name ? "is-invalid" : ""
                        }`}
                        value={formData.name}
                        onChange={(e) => handleInput("name", e.target.value)}
                      />
                      {errors.name && (
                        <div className="invalid-feedback">{errors.name}</div>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-4 align-items-center">
                    <Col md={3}>
                      <label className="fw-bold">Description</label>
                    </Col>
                    <Col md={9}>
                      <textarea
                        className="form-control"
                        rows={4}
                        value={formData.description}
                        onChange={(e) =>
                          handleInput("description", e.target.value)
                        }
                      />
                    </Col>
                  </Row>
                </Form>
              </Loader>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CategoryForm;
